import {
  MerchantChainConfigStatus,
  WalletSmartAccountType,
} from "@wallet-manager/node-types/dist/src/postgres/const";
import { isNil } from "lodash";
import React from "react";
import { useWalletVersionContext } from "src/components/Common/WalletVersionSelection/WalletVersionProvider";
import { SingleSelection } from "src/components/GeneralSelection";
import { useTranslation } from "src/hooks";

interface IProps {
  value: string;
  onChange: (contractVersion: string) => void;
  onClear?: () => void;
  chainType?: number;
  chainId?: number;
}

const WalletVersionSingleSelection = (props: IProps) => {
  const { value, onChange, onClear, chainType, chainId } = props;

  const { t, tc } = useTranslation("walletDeploymentRequests");
  const { list, filterList, getOne } = useWalletVersionContext();

  const filteredList = filterList({
    chainType,
    chainId,
    smartAccountType: WalletSmartAccountType.MultisignWallet,
    walletEnableStatus: MerchantChainConfigStatus.Enabled,
  });

  const createEnum = () => {
    const result: Record<string, string> = {};
    filteredList?.forEach((item) => {
      result[item.wallet_version] = String(item.wallet_version);
    });

    return result;
  };

  const selectionNameFunc = (item: string) => {
    const target = getOne({
      walletVersion: item,
      chainType,
      chainId,
    });

    return `${item}${target?.description ? `(${target.description})` : ""}`;
  };
  const enumData = createEnum();

  return (
    <>
      <SingleSelection
        label={tc("phSelection", {
          fieldName: t("contract_wallet_version"),
        })}
        value={value || ""}
        clearSelect={onClear || (() => {})}
        onChange={(e) => onChange(e.target.value)}
        enumData={enumData}
        nameFn={selectionNameFunc}
        disabled={isNil(chainType) || isNil(chainId)}
      />
    </>
  );
};

export default WalletVersionSingleSelection;
